import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useSWR from 'swr';
export function useSaleLimit(id, shouldFetch) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id || $[2] !== shouldFetch) {
    t1 = () => {
      if (!shouldFetch) {
        return null;
      }
      return `${FUNNELS_API}/step/${id}/sales-count`;
    };
    $[1] = id;
    $[2] = shouldFetch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: saleLimitData
  } = useSWR(t1, fetcher);
  let t2;
  if ($[4] !== saleLimitData) {
    t2 = {
      saleLimitData
    };
    $[4] = saleLimitData;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}